import { render, staticRenderFns } from "./OnboardingSidebar.vue?vue&type=template&id=714ea4b2&scoped=true&"
import script from "./OnboardingSidebar.vue?vue&type=script&lang=js&"
export * from "./OnboardingSidebar.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingSidebar.vue?vue&type=style&index=0&id=714ea4b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "714ea4b2",
  null
  
)

export default component.exports